import { mixin } from './common.js'
export default {
  mixins: [mixin],
  template: `
<div class="notfound has-text-centered">
  <i class="c-icon cachalog-404">
    <span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span><span class="path9"></span><span class="path10"></span><span class="path11"></span><span class="path12"></span><span class="path13"></span><span class="path14"></span><span class="path15"></span><span class="path16"></span><span class="path17"></span><span class="path18"></span><span class="path19"></span>
  </i>
  <p class="is-cs-3 is-c-text has-text-weight-bold">お探しのページが見つかりませんでした</p>
  <p class="is-cs-4 is-c-text">ページが移動または削除された可能性があります</p>
</div>
`
}



// WEBPACK FOOTER //
// ./src/components/404.js